import { useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import type { ChatThreadEvent, ProductsAdditionalFields } from '~/App/ChatThreads/@types'
import { IncomingMessage } from '~/App/components/messages/IncomingMessage'
import MessageText from '~/App/components/messages/MessageText'
import { Button } from '~/DesignSystem/components/button'
import { MessageBottomContent } from '~/DesignSystem/components/messages'

import { ProductCard } from './ProductCard'

const LIMIT = 3

type IncommingProductsMessageProps = {
  event: ChatThreadEvent
  data: NonNullable<ProductsAdditionalFields['product_items']>
}

function IncommingProductsMessage({ event, data }: IncommingProductsMessageProps) {
  const [expanded, setExpanded] = useState(false)

  const hasMore = data.length > LIMIT

  const items = useMemo(() => {
    return !expanded ? data.slice(0, LIMIT) : data
  }, [data, expanded])

  const toggleExpanded = () => setExpanded(expanded => !expanded)

  return (
    <IncomingMessage
      time={event.attributes.timestamp * 1000}
      owner={event.attributes.author?.data?.attributes.display_name || undefined}
    >
      <MessageText>
        {event.attributes.text_in_chatter_language || event.attributes.text}
      </MessageText>
      <MessageBottomContent className="flex flex-col gap-2">
        {items.map(item => (
          <ProductCard key={item.sync_source_ext_id} data={item} />
        ))}
        {hasMore && (
          <Button variant="ghost" className="w-full" onClick={toggleExpanded}>
            <FormattedMessage
              id={expanded ? 'productsMessage.viewLess' : 'productsMessage.viewMore'}
            />
          </Button>
        )}
      </MessageBottomContent>
    </IncomingMessage>
  )
}

export default IncommingProductsMessage
